module.exports = __webpack_public_path__ + "img/estructuras.d20035aa.png";